export type LiveStatus =
    | 'working_moving'
    | 'working_on_site'
    | 'working_idle'
    | 'working_untracked'
    | 'after_hours_working'
    | 'before_hours_working'
    | 'off_hours'
    | 'not_tracking'
    | 'no_data_today'

// Moonlight indigo — signals "on the clock outside the configured working
// window." Distinct from the green working colors and the neutral off-hours
// gray so managers can spot late-runners at a glance.
const MOONLIGHT = '#6366F1'

export const LIVE_STATUS_LABELS: Record<LiveStatus, string> = {
    working_moving: 'Moving',
    working_on_site: 'On site',
    working_idle: 'Idle',
    working_untracked: 'No job selected',
    after_hours_working: 'Working late',
    before_hours_working: 'Early start',
    off_hours: 'Off hours',
    not_tracking: 'Not tracking',
    no_data_today: 'No activity today',
}

// Sort order:
//   1. working_untracked    — clocked-window but no job picked (manager flag)
//   2. after_hours_working  — working late
//   3. before_hours_working — early start
//   4. working_idle         — not moving, not on site, within hours
//   5. working_on_site
//   6. working_moving
//   7. off_hours
//   8. not_tracking
//   9. no_data_today
export const LIVE_STATUS_SORT_ORDER: Record<LiveStatus, number> = {
    working_untracked: 0,
    after_hours_working: 1,
    before_hours_working: 2,
    working_idle: 3,
    working_on_site: 4,
    working_moving: 5,
    off_hours: 6,
    not_tracking: 7,
    no_data_today: 8,
}

export function isWorkingStatus(status: LiveStatus): boolean {
    return (
        status === 'working_moving' ||
        status === 'working_on_site' ||
        status === 'working_idle' ||
        status === 'working_untracked'
    )
}

// "Clocked in but outside the schedule" — a distinct third category alongside
// working and off. Used to count the Late chip and to decide whether to show
// the mini-map on the card.
export function isOutsideHoursWorking(status: LiveStatus): boolean {
    return status === 'after_hours_working' || status === 'before_hours_working'
}

export { MOONLIGHT as MOONLIGHT_COLOR }
